module.exports = __webpack_public_path__ + "img/raju.609b37bd.png";